import { PARTNER_CONSOLE_BASE } from "../pages/Partner/PartnerConsole/partnerConsoleRoutes";
import { getActiveWorkspaceSlug } from "./workspaceStorage";
import { readTabUserData } from "./tabAuthStorage";

export function isPartnerConsolePath(pathname = "") {
  const p = String(pathname || "");
  return p === PARTNER_CONSOLE_BASE || p.startsWith(`${PARTNER_CONSOLE_BASE}/`);
}

let partnerDashboardAiContext = {
  enabled: false,
  dominioIds: [],
};

/** Sincronizado pelo PartnerDashboardProvider para rotear IA via /billing/partner/… */
export function setPartnerDashboardAiContext(ctx) {
  partnerDashboardAiContext = {
    enabled: Boolean(ctx?.enabled),
    dominioIds: Array.isArray(ctx?.dominioIds)
      ? ctx.dominioIds.map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0)
      : [],
  };
}

export function getPartnerDashboardAiContext() {
  return partnerDashboardAiContext;
}

export function isPartnerPortalSession(userData) {
  if (!userData || typeof userData !== "object") return false;
  if (String(userData.scope || "").toLowerCase() === "partner") return true;
  return false;
}

export function isPartnerAssistantContext() {
  if (typeof window !== "undefined" && isPartnerConsolePath(window.location?.pathname || "")) {
    return true;
  }
  try {
    return isPartnerPortalSession(readTabUserData());
  } catch {
    return false;
  }
}

/** Tenant ativo no browser (slug/schema) — ausente no portal do representante após limpar storage. */
export function hasActiveTenantWorkspaceContext() {
  return Boolean(getActiveWorkspaceSlug());
}
